import React from 'react';
import Layout from '../components/layout/Layout';
import TextBox from '../components/residential/TextBox';
import Esid from '../components/residential/Esid';
import Profile from '../components/residential/Profile';
import CreditCheck from '../components/residential/CreditCheck';
import Result from '../components/residential/Result';
import FinalValidation from '../components/residential/FinalValidation';
import Residential_bg from '../svg/Residential_bg.jpg';
import ZipBox from '../components/ZipBox.js';

// Components
import WebProducts from '../components/residential/WebProducts';
import axios from 'axios';

// utilities
import * as Validate from '../utilities/Validate';
import _ from 'underscore';
import moment from 'moment';

class Residential extends React.Component {
  state = {
    zipCode: '',
    address: null,
    distributionPoints: [],
    distributionPoint: null,
    email: '',
    password: '',
    password2: '',
    phoneNumber: '',
    dateOfBirth: '',
    fullName: '',
    SSN: '',
    profileError: null,
    webProducts: [],
    ercotPriceData: null,
    errors: {
      zipCode: null,
      fullName: null,
      email: null,
      password: null,
      password2: null,
      phoneNumber: null,
      moveInDate: null
    },
    accountCompleted: false,
    validZip: false,
    creditCheckCompleted: false,
    moveInDate: null,
    average5DayPrice: null,
    loaders: {
      zipCodeLoader: false,
      completeEnrollment: false
    }
  };

  getDistributionPointsByZip = async () => {
    // here we are verifying that the zip code entered is serviceable and getting the ercot rates for the entered zip codes
    const { zipCode } = this.state;
    try {
      let distributionPointsResponse = await axios.get(
        `https://hybridpowertexas.io/api/auth/distributionPointsByZipCode?ZipCode=${zipCode}`
      );
      // console.log({ distributionPointsResponse })
      if (distributionPointsResponse.data.success) {
        await this.getLMPData();
        this.setState({ validZip: true }, () => {
          document.getElementById('scroll1').scrollIntoView({ behavior: 'smooth' });
        });
      }
    } catch {
      this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          zipCode: 'Service unavailable at this zip code'
        }
      }));
    }
  };

  getDistributionPointsByAddress = async () => {
    const { address, zipCode } = this.state;

    try {
      let distributionPointsResponse = await axios.get(
        `https://hybridpowertexas.io/api/auth/distributionPointsByAddress?address=${address}&zip=${zipCode}&city=`
      );
      // console.log({ distributionPointsResponse })
      if (distributionPointsResponse.data.success) {
        this.setState({
          distributionPoints: distributionPointsResponse.data.data
        });
      }
    } catch (error) {
      this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          address: 'Address not found in zip code area'
        }
      }));
    }
  };

  setDistributionPoint = distributionPoint => {
    this.setState({ distributionPoint }, async () => {
      const config = {
        params: {
          DistributionServiceProviderID: distributionPoint.distributionServiceProviderID,
          CompanyID: 1,
          LanguageID: 1,
          ZipCode: distributionPoint.zipCode
        }
      };
      try {
        let webProductsResponse = await axios.get(
          `https://hybridpowertexas.io/api/auth/webProductsByZip`,
          config
        );
        // console.log({ webProductsResponse })

        if (webProductsResponse.data.success) {
          this.setState(
            {
              webProducts: webProductsResponse.data.data.webProducts.filter(
                (product, index) => index < 3
              )
            },
            () => {
              setTimeout(() => {
                document.getElementById('webProducts').scrollIntoView({ behavior: 'smooth' });
              }, 300);
            }
          );
        }
      } catch (error) {
        // handle web products error
      }
    });
  };

  handleChange = (stateVariable, value) => {
    this.setState(prevState => ({
      [stateVariable]: value,
      errors: {
        ...prevState.errors,
        [stateVariable]: null
      }
    }));
  };

  runCreditCheck = async () => {
    const { SSN, dateOfBirth, fullName } = this.state;
    let firstName = fullName.split(' ')[0];
    let lastName = fullName.split(' ')[1];

    const data = {
      SkipCreditCheck: false,
      IsMaxDepositRequest: false,
      WaiveDeposit: false,
      CompanyID: 1,
      FirstName: firstName,
      LastName: lastName,
      SSN: SSN
    };
    let isUnder18 = moment(new Date()).year() - moment(dateOfBirth).year() < 18;

    const checks = [
      {
        field: 'SSN',
        error: SSN && SSN.length !== 10,
        message: 'Invalid SSN',
        required: true
      },
      {
        field: 'dateOfBirth',
        error: dateOfBirth && isUnder18,
        message: 'Must be 18 or older',
        required: true
      }
    ];

    let errors = { ...this.state.errors };
    let success = true;
    _.each(checks, check => {
      let inputValue = check.field;
      let errorMessage = check.message;
      // set error if required field is not filled out
      if (check.required && !this.state[inputValue]) {
        success = false;
        errors[inputValue] = 'This field is required';
      }
      // set specific error message if validation fails
      if (check.error) {
        success = false;
        errors[inputValue] = errorMessage;
      }
    });

    if (success) {
      try {
        let creditCheckResponse = await axios.post(
          `https://hybridpowertexas.io/api/auth/runCreditCheck`,
          { data }
        );
        // console.log({ creditCheckResponse })
        if (creditCheckResponse.data.success) {
          // display relevant results of credit check
        }
      } catch (error) {
        // handle credit check error display
      }
    } else {
      this.setState({ errors });
    }
  };

  createAccount = async () => {
    const {
      distributionPoint,
      phoneNumber,
      fullName,
      email,
      password,
      password2,
      moveInDate,
      loaders
    } = this.state;
    let firstName = fullName.split(' ')[0];
    let lastName = fullName.split(' ')[1];

    let body = {
      userInformation: {
        email,
        password,
        password2
      },
      // need to make sure that this is setup properly. Add any missing fields that should be specified.
      account: {
        companyID: 1,
        accountTypeID: 1,
        languageID: 1,
        distributionPoints: [
          {
            ...distributionPoint,
            switchOrMoveInDate: `${moment(moveInDate).format('YYYY-MM-DD')}T00:00:00.000Z`
          }
        ],
        persons: [
          {
            personContacts: [
              {
                contactTypeID: 1,
                contactValue: phoneNumber
              }
            ],
            personTypeID: 1,
            firstName: firstName,
            lastName: lastName,
            middleInitial: '',
            userName: 'default',
            password: password,
            emailAddress: email,
            isPrimary: true,
            notificationChannels: [
              {
                notificationChannelID: 1
              },
              {
                notificationChannelID: 2
              }
            ]
          }
        ],
        accountAddress: {
          address1: distributionPoint.address1,
          address2: distributionPoint.address2,
          city: distributionPoint.city,
          postalCode: distributionPoint.zipCode,
          state: distributionPoint.stateCode
        },
        billDeliveryMethod: [
          {
            billDeliveryMethodID: 2
          }
        ]
      },
      accountDepositOption: {
        createMaxDeposit: true
      }
    };

    // all error handling for profile
    let invalidMoveInDate = new Date(moveInDate) <= new Date();
    const checks = [
      {
        field: 'fullName',
        error: firstName && (!firstName || !lastName),
        message: 'Please enter your full name',
        required: true
      },
      {
        field: 'email',
        error: email && !Validate.Email(email),
        message: 'Email is improperly formatted',
        required: true
      },
      {
        field: 'password',
        error: password && password.length < 6,
        message: 'password must be at least 6 characters',
        required: true
      },
      {
        field: 'password2',
        error: password && password2 && password !== password2,
        message: 'passwords must match',
        required: true
      },
      {
        field: 'phoneNumber',
        error: phoneNumber && phoneNumber.length !== 10,
        message: 'Invalid phone number',
        required: true
      },
      {
        field: 'moveInDate',
        error: invalidMoveInDate,
        message: 'Move in date cannot be before today.',
        required: true
      }
    ];

    let errors = { ...this.state.errors };
    let success = true;
    _.each(checks, check => {
      let inputValue = check.field;
      let errorMessage = check.message;
      // set error if required field is not filled out
      if (check.required && !this.state[inputValue]) {
        success = false;
        errors[inputValue] = 'This field is required';
      }
      // set specific error message if validation fails
      if (check.error) {
        success = false;
        errors[inputValue] = errorMessage;
      }
    });

    let setCompleteEnrollmentLoader = type => {
      this.setState(prevState => ({
        loaders: {
          ...prevState.loaders,
          completeEnrollment: type
        }
      }));
    };

    if (success) {
      try {
        if (!loaders.completeEnrollment) {
          setCompleteEnrollmentLoader(true);
          let accountResponse = await axios.post(
            `https://hybridpowertexas.io/api/auth/processAccountEnrollment`,
            { data: body }
          );
          console.log({ accountResponse });
          if (accountResponse.data.success) {
            setCompleteEnrollmentLoader(false);
            // this.setState({ accountCompleted: true }, () => {
            // 	document.getElementById('creditCheck').scrollIntoView({ behavior: 'smooth' })
            // })
          } else {
            let profileError = accountResponse.data.errors[0].message;
            if (profileError && typeof profileError === 'string') {
              this.setState({ profileError });
            }
            setCompleteEnrollmentLoader(false);
          }
        }
      } catch (error) {
        console.log(error);
        setCompleteEnrollmentLoader(false);
        if (typeof error === 'string') {
          this.setState({
            profileError: error
          });
        } else {
          this.setState({
            profileError:
              'Something went wrong when trying to create your account. Please try again or reach out to support.'
          });
        }
      }
    } else {
      this.setState({ errors });
    }
  };

  setWebProducts = product => {
    console.log(product);
    this.setState(
      prevState => ({
        distributionPoint: {
          ...prevState.distributionPoint,
          productID: product.productID
        }
      }),
      () => {
        console.log(document.getElementById('profile').offsetHeight);
        document.getElementById('profile').scrollIntoView({ behavior: 'smooth' });
      }
    );
  };

  // gets the last 5 days of live Ercot market prices for energy.
  getLMPData = async () => {
    const { loaders } = this.state;
    let setZipCodeLoader = type => {
      this.setState(prevState => ({
        loaders: {
          ...prevState.loaders,
          zipCodeLoader: type
        }
      }));
    };
    setZipCodeLoader(true);

    const config = {
      headers: { Authorization: this.props.accessToken },
      params: { nodeID: 1 }
    };
    let LMPResponse = await axios.get('https://hybridpowertexas.io/api/auth/getLMPRates', config);
    console.log({ LMPResponse });
    if (LMPResponse.data.success) {
      setZipCodeLoader(false);
      // from and to date will always be for last 5 days of data
      let from = moment()
        .subtract(5, 'd')
        .toDate();
      let to = moment().toDate();

      // create date array with all dates between to and from dates.
      let dates = [];
      let currentDate = moment(from).startOf('day');
      let lastDate = moment(to).startOf('day');

      while (currentDate.add(1, 'days').diff(lastDate) < 0) {
        dates.push(currentDate.clone().toDate());
      }
      let ercotPriceObject = {};
      let dataArray = LMPResponse.data.data;
      // combine all the 15 min prices by day. Storing this in an object for simplicity and converting to an array further below.
      _.each(dataArray, _15minPriceObj => {
        let date = moment(_15minPriceObj.priceDate)
          .startOf('day')
          .format('MMM DDDo');
        let price = _15minPriceObj.marketPrice;
        let existingMarketPrice = ercotPriceObject[date];
        if (existingMarketPrice) {
          ercotPriceObject[date].push(price);
        } else {
          ercotPriceObject[date] = [price];
        }
      });

      let totalSum = 0;
      ercotPriceObject = _.mapObject(ercotPriceObject, (priceArray, key) => {
        // get the average price on each day
        let pricesLength = priceArray.length;
        let priceSum = priceArray.reduce((sum, currentValue) => (sum += currentValue));
        let averageDayPrice = priceSum / pricesLength;
        totalSum = totalSum += averageDayPrice;
        return averageDayPrice.toFixed(2);
      });
      let average5DayPrice = `$${(totalSum / 5 / 1000).toFixed(2)}`; // static average based on current 5 day limitation. No need to make this dynamic unless this is updated.

      // converts the data to an array of objects (format for recharts)
      let ercotPriceData = [];
      _.map(ercotPriceObject, (value, key) => {
        ercotPriceData.push({
          date: key,
          price: value
        });
      });
      this.setState({
        ercotPriceData,
        average5DayPrice
      });
    } else {
      setZipCodeLoader(false);
    }
  };

  render() {
    const {
      loaders,
      profileError,
      ercotPriceData,
      average5DayPrice,
      moveInDate,
      validZip,
      zipCode,
      distributionPoints,
      distributionPoint,
      phoneNumber,
      email,
      password,
      fullName,
      webProducts,
      errors,
      SSN,
      accountCompleted,
      dateOfBirth,
      creditCheckCompleted
    } = this.state;
    return (
      <Layout>
        <div class="bg-white">
          <div
            class="w-full md:pt-0 md:bg-cover"
            style={{ backgroundImage: `url(${Residential_bg})` }}
          >
            <div class="relative overflow-hidden">
              <div class="mx-auto max-w-screen-xl">
                <div
                  class="flex flex-col flex-1 pt-24 pb-16 text-center"
                  style={{ justifyContent: 'center', alignItems: 'center', height: '90vh' }}
                >
                  <h2 class="text-4xl tracking-loose font-extrabold text-white sm:text-5xl sm:leading-none md:text-7xl">
                    START SAVING TODAY
                  </h2>
                  <h3 class=" tracking-widest mx-auto uppercase font-extrabold text-white sm:text-lg md:text-4xl">
                    electricity for your home
                  </h3>

                  <ZipBox
                    loaders={loaders}
                    getDistributionPoints={this.getDistributionPointsByZip}
                    handleChange={this.handleChange}
                    errors={errors}
                  />
                </div>
              </div>
            </div>
          </div>

          {validZip && (
            <div id="scroll1">
              <TextBox
                id="textBox"
                average5DayPrice={average5DayPrice}
                ercotPriceData={ercotPriceData}
                zipCode={zipCode}
              />
              <div id="scroll1" class="relative bg-black">
                <Esid
                  resetDistributionPoint={() => this.setState({ distributionPoint: null })}
                  getDistributionPointsByAddress={this.getDistributionPointsByAddress}
                  handleChange={this.handleChange}
                  distributionPoints={distributionPoints}
                  setDistributionPoint={this.setDistributionPoint}
                  distributionPoint={distributionPoint}
                  errors={errors}
                />
                <div id="webProducts">
                  {webProducts && webProducts.length > 0 && (
                    <WebProducts setWebProduct={this.setWebProducts} webProducts={webProducts} />
                  )}
                </div>
              </div>
              {distributionPoint && distributionPoint.productID && (
                <>
                  <div class="mt-10 border border-t border-darkYellow"></div>

                  <Profile
                    loaders={loaders}
                    profileError={profileError}
                    handleChange={this.handleChange}
                    distributionPoint={distributionPoint}
                    createAccount={this.createAccount}
                    phoneNumber={phoneNumber}
                    fullName={fullName}
                    email={email}
                    password={password}
                    errors={errors}
                    moveInDate={moveInDate}
                  />

                  <div id="creditCheck">
                    {accountCompleted && (
                      <>
                        <div class="relative bg-black" id="scroll2">
                          <div class="px-10 py-6 relative max-w-screen-xl mx-auto flex items-center justify-between">
                            <div class="inline-flex">
                              <img
                                class=" pr-4 h-12 w-auto"
                                src="https://imgix.cosmicjs.com/788bb580-1d16-11eb-8ec3-0f4c230fe58a-number-4-01.svg"
                                alt="Logo"
                              ></img>
                              <h2 class="tracking-wide font-extrabold max-w-5xl mx-auto text-white text-4xl">
                                Credit Check
                              </h2>
                            </div>
                            <svg
                              class="h-12 w-12"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="white"
                              viewBox="0 0 24 24"
                            >
                              <path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" />
                            </svg>
                          </div>
                        </div>

                        <CreditCheck
                          handleChange={this.handleChange}
                          runCreditCheck={this.runCreditCheck}
                          SSN={SSN}
                          dateOfBirth={dateOfBirth}
                          errors={errors}
                        />
                      </>
                    )}
                  </div>

                  <div id="result">
                    {creditCheckCompleted && (
                      <>
                        <div class="relative bg-black">
                          <div class="px-10 py-6 relative max-w-screen-xl mx-auto flex items-center justify-between">
                            <div class="inline-flex">
                              <img
                                class=" pr-4 h-12 w-auto"
                                src="https://imgix.cosmicjs.com/4dcbe760-1d2b-11eb-8ec3-0f4c230fe58a-number-5-01.svg"
                                alt="Logo"
                              ></img>
                              <h2 class="tracking-wide font-extrabold max-w-5xl mx-auto text-white text-4xl">
                                Pay Deposit/Verification Result
                              </h2>
                            </div>
                            <svg
                              class="h-12 w-12"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="white"
                              viewBox="0 0 24 24"
                            >
                              <path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" />
                            </svg>
                          </div>
                        </div>

                        <Result />
                      </>
                    )}
                  </div>
                  {creditCheckCompleted && accountCompleted && (
                    <>
                      <div class="relative bg-yellow">
                        <div class="px-10 py-6 relative max-w-screen-xl mx-auto flex items-center justify-between">
                          <div class="inline-flex">
                            <h2 class="tracking-wide font-extrabold max-w-5xl mx-auto text-white text-4xl">
                              Final Steps
                            </h2>
                          </div>
                          <svg
                            class="h-12 w-12"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="white"
                            viewBox="0 0 24 24"
                          >
                            <path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" />
                          </svg>
                        </div>
                      </div>

                      <FinalValidation />
                      <div />
                    </>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      </Layout>
    );
  }
}

export default Residential;

/*	<svg
										class="h-12 w-12"
										xmlns="http://www.w3.org/2000/svg"
										fill="white"
										viewBox="0 0 24 24"
									>
										<path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" />
									</svg>
									
										<div class="px-10 py-6 relative max-w-screen-xl mx-auto flex items-center justify-between">
									<div class="inline-flex">
										<img
											class=" pr-4 h-12 w-auto"
											src="https://imgix.cosmicjs.com/5fc2c5b0-1c9f-11eb-8ec3-0f4c230fe58a-number-1-01.svg"
											alt="Logo"
										></img>
										<h2 class="tracking-wide font-extrabold max-w-5xl mx-auto text-white text-4xl">
											Enter Your Address - <span class="text-yellow">{zipCode}</span>
										</h2>
									</div>

								</div>
									
									*/
